import { TextField } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";

const InvoiceNumber = () => {
  const { values, handleChange, handleBlur, touched, errors } =
    useFormikContext();
  return (
    <TextField
      fullWidth
      size="small"
      label="Invoice Number"
      value={values["invoice_number"]}
      name="invoice_number"
      onChange={handleChange}
      onBlur={handleBlur}
      required
      error={touched.invoice_number && Boolean(errors.invoice_number)}
      helperText={touched.invoice_number && errors.invoice_number}
    />
  );
};

export default InvoiceNumber;
